// plugins/pinia.client.ts
import { createPinia, storeToRefs, type StoreDefinition } from "pinia";

export const pinia = createPinia();

export default defineNuxtPlugin((nuxtApp) => {
  // nuxtApp.vueApp.use(pinia);
  // return {
  //   provide: {
  //     pinia,
  //   },
  // };
});

interface StoreInitializationOptions {
  immediate?: boolean;
}

// createSharedReactiveStore
// 创建全局响应式 store,可在普通js文件的顶层直接使用
// 默认立即初始化
// 可选惰性初始化：返回一个 Proxy 对象。 当首次访问任何属性 (如 store.count 或 store.increment) 时，get() 拦截器会触发。此时我们才真正地初始化 store。

export const createSharedReactiveStore = <T extends StoreDefinition>(
  storeDefinition: T,
  options: StoreInitializationOptions = {},
) => {
  const { immediate = true } = options;
  let cachedStoreInstance: any = null;

  const getOrCreateStoreInstance = () => {
    if (!cachedStoreInstance) {
      const store = storeDefinition(pinia);
      cachedStoreInstance = {
        ...store,
        ...storeToRefs(store),
      };
    }
    return cachedStoreInstance;
  };

  if (immediate) {
    return getOrCreateStoreInstance();
  }

  return new Proxy(
    {},
    {
      get(emptyTarget, propertyKey, receiver) {
        const storeInstance = getOrCreateStoreInstance();
        return Reflect.get(storeInstance, propertyKey, receiver);
      },
      set(emptyTarget, propertyKey, newValue, receiver) {
        const storeInstance = getOrCreateStoreInstance();
        return Reflect.set(storeInstance, propertyKey, newValue, receiver);
      },
    },
  );
};